import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl'
import { each } from 'lodash'

import { callApi } from '../services/fetchService'
import { loadGlobals } from '../actions'

import DataTable from '../components/DataTable'
import FaIcon from '../components/FaIcon'
import TableButton from '../components/TableButton'

import { Button, message } from 'antd'



class Actions extends Component {

    state = {
        data: [],
        loading: false
    }

    static propTypes = {
        comboboxes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }

    fetch = (params = {}) => {
        const { intl, comboboxes } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'actions'
        }).then((data) => {
            this.setState({
                data: each(data, (item) => {
                    item.category = comboboxes.byKey["action-categories"][item.category].value
                    item.plantsCount = item.plants.length
                }),
                loading: false
            })
        }).catch((err) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    delete = (action) => {
        const { intl, loadGlobals } = this.props
        callApi({
            endpoint: 'actions/' + action.id,
            method: 'DELETE'
        }).then((data) => {
            message.success(intl.formatMessage({id: 'misc.deleteSuccess'}))
            this.fetch()
            loadGlobals()
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
        })
    }

    rowsConfig = (record) => ({
        style: { cursor: 'pointer' },
        onClick: (e) => this.props.history.push('/action/' + record.id)
    })

    render() {
        const { data, loading } = this.state

        const columns = [
            { title: "actions.nameColumn", dataIndex: "name", type: "string", sorter: true },
            { title: "actions.categoryColumn", dataIndex: "category", type: "string", sorter: true },
            { title: "actions.plantsCountColumn", dataIndex: "plantsCount", type: "number", sorter: true },
            { title: "misc.actions", width: "100px", key: "action", render: (record) => (
                <TableButton color="red" icon="trash-alt" onClick={this.delete} value={record} confirm />
            ) }
        ]

        return (
            <div>
                <h1><FaIcon icon="bullseye" fixedWidth /> <FormattedMessage id="actions.title" /></h1>
                <div className="action-bar"><Link to="/action"><Button><FaIcon icon="plus"/> <FormattedMessage id="actions.addAction" /></Button></Link></div>
                <DataTable columns={columns} dataSource={data} loading={loading} rowKey="id" size="middle" onRow={this.rowsConfig} />
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    comboboxes: state.comboboxes
})

export default withRouter(injectIntl(connect(mapStateToProps, {
    loadGlobals
})(Actions)))


// WEBPACK FOOTER //
// ./src/views/Actions.js